<template>
  <Sidebar :content="sidebarContent" currentSidebarTab="SettingsGeneral" :hideProjectsTab="true">
    <div class="flex flex-1 flex-col overflow-hidden">
      <div class="flex flex-1 items-stretch overflow-hidden">
        <main class="flex-1 overflow-y-auto">
          <div class="mt-8 pl-8 pr-8">
            <h1 class="text-3xl font-extrabold text-gray-900">
              {{ $t("admin.settings.user.title") }}<span>&#8203;</span>
            </h1>
            <div class="mt-4 divide-y divide-gray-200">
              <div class="space-y-1">
                <p class="max-w-2xl text-sm text-gray-500">
                  {{ $t("admin.settings.user.sub_title") }}
                </p>
              </div>
              <div class="mt-6 w-1/2">
                <dl class="divide-y divide-gray-200">
                  <div class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("admin.settings.user.table_name") }}
                    </dt>
                    <dd class="mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      <span class="grow">{{ this.userName }}</span>
                    </dd>
                  </div>
                  <div class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:pt-5">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("admin.settings.user.table_mail") }}
                    </dt>
                    <dd class="mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      <span class="grow">{{ this.userMail }}</span>
                    </dd>
                  </div>
                  <div
                    class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-b sm:border-gray-200 sm:py-5"
                  >
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("admin.settings.user.table_company") }}
                    </dt>
                    <dd class="mt-1 flex text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      <span class="grow">{{ this.userCompany }}</span>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </Sidebar>
</template>

<script>
import { LanguageIcon, UserIcon, HomeIcon } from "@heroicons/vue/24/solid";
import Sidebar from "@/components/layout/Sidebar.vue";

export default {
  name: "SettingsGeneral",

  data() {
    return {
      sidebarContent: [],
      userCompany: "",
      userName: "",
      userMail: "",
    };
  },
  mounted() {
    this.addSidebarContent();
    const user = this.$store.state.user;
    this.userCompany = user.company;
    this.userName = user.name;
    this.userMail = user.email;
  },
  components: {
    Sidebar,
  },
  methods: {
    addSidebarContent() {
      let listEntry = {
        name: this.$t("partials.sidebar.projects"),
        href: "/",
        icon: HomeIcon,
        current: false,
        section: "",
      };
      this.sidebarContent.push(listEntry);

      listEntry = {
        name: this.$t("app_features.settings.user"),
        href: "/settings/user",
        icon: UserIcon,
        current: "true",
        section: "",
      };
      this.sidebarContent.push(listEntry);

      listEntry = {
        name: this.$t("app_features.settings.language"),
        href: "/settings/language",
        icon: LanguageIcon,
        current: false,
        section: "",
      };
      this.sidebarContent.push(listEntry);
    },
  },
  setup() {
    return {};
  },
};
</script>
